module.exports = __webpack_public_path__ + "img/t3-c7.0f2f1fb8.png";